import Reveal from "./ui/Reveal";

const BENEFICIOS = [
  {
    icono: "https://cdn-icons-png.flaticon.com/512/2738/2738835.png",
    alt: "Icono proteína",
    titulo: "Proteína de verdad",
    texto:
      "El maní es una fuente natural de proteína vegetal y grasas buenas que aportan energía duradera.",
  },
  {
    icono: "https://cdn-icons-png.flaticon.com/512/3967/3967382.png",
    alt: "Icono producto natural",
    titulo: "Sin aditivos",
    texto:
      "Nada de azúcares refinados, aceites hidrogenados ni conservantes. Solo maní, como debe ser.",
  },
  {
    icono: "https://cdn-icons-png.flaticon.com/512/7903/7903812.png",
    alt: "Icono saludable",
    titulo: "Saludable y saciante",
    texto:
      "Ideal para deportistas y para quienes cuidan su alimentación sin renunciar al sabor.",
  },
  {
    icono: "https://cdn-icons-png.flaticon.com/512/2037/2037483.png",
    alt: "Icono hecho a mano",
    titulo: "Hecha artesanalmente",
    texto:
      "Tostamos y molemos en lotes pequeños para cuidar el sabor y la textura de cada frasco.",
  },
];

const PASOS = [
  {
    numero: "01",
    titulo: "Seleccionamos el maní",
    texto: "Escogemos maní de calidad, limpio y bien seleccionado.",
  },
  {
    numero: "02",
    titulo: "Tostado lento",
    texto: "Lo tostamos con paciencia para liberar todo su aroma natural.",
  },
  {
    numero: "03",
    titulo: "Molido al instante",
    texto: "Molemos hasta lograr una textura cremosa, sin agregar nada más.",
  },
  {
    numero: "04",
    titulo: "Envasado fresco",
    texto: "Llenamos cada frasco de 1 Kg y lo sellamos para mantener su frescura.",
  },
];

const Beneficios = () => {
  return (
    <section id="beneficios" className="bg-cream py-20 md:py-section">
      <div className="mx-auto max-w-container px-5 md:px-16">
        {/* Encabezado */}
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="text-xs font-semibold uppercase tracking-label text-secondary">
            La diferencia Agora
          </span>
          <h2 className="mt-3 font-literata text-2xl font-bold text-charcoal sm:text-3xl md:text-4xl">
            Buena por dentro, natural por fuera
          </h2>
          <p className="mt-4 text-base text-ink-variant sm:text-lg">
            Creemos que un buen alimento no necesita ingredientes raros. Por eso
            nuestra mantequilla es 100% maní, sin trucos ni etiquetas que no
            puedas pronunciar.
          </p>
        </Reveal>

        {/* Tarjetas de beneficios */}
        <ul className="mt-12 grid gap-5 sm:mt-16 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
          {BENEFICIOS.map((beneficio, indice) => (
            <Reveal
              as="li"
              key={beneficio.titulo}
              delay={indice * 80}
              className="group rounded-xl border border-peanut/40 bg-white p-7 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-card-hover sm:p-8"
            >
              <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-peanut/15 transition-colors duration-300 group-hover:bg-peanut/25">
                <img
                  src={beneficio.icono}
                  alt={beneficio.alt}
                  className="h-9 w-9"
                  loading="lazy"
                />
              </span>
              <h3 className="mt-5 font-literata text-xl font-semibold text-charcoal">
                {beneficio.titulo}
              </h3>
              <p className="mt-3 text-base text-ink-variant">{beneficio.texto}</p>
            </Reveal>
          ))}
        </ul>

        {/* Proceso de elaboración (todo natural) */}
        <div className="mt-16 grid items-center gap-10 md:mt-24 lg:grid-cols-2 lg:gap-16">
          <Reveal className="overflow-hidden rounded-xl shadow-card">
            <img
              src="https://images.pexels.com/photos/6823299/pexels-photo-6823299.jpeg?auto=compress&cs=tinysrgb&w=1000"
              alt="Pan tostado con mantequilla de maní y frutos secos"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </Reveal>

          <Reveal delay={120} className="px-2 sm:px-0">
            <span className="text-xs font-semibold uppercase tracking-label text-secondary">
              Así la hacemos
            </span>
            <h3 className="mt-3 font-literata text-2xl font-bold text-charcoal md:text-3xl">
              Un proceso simple y 100% natural
            </h3>
            <ol className="mt-8 space-y-8 pl-3 sm:pl-0">
              {PASOS.map((paso) => (
                <li key={paso.numero} className="flex items-start gap-5">
                  <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border border-peanut/50 bg-peanut/10 font-literata text-lg font-bold text-secondary">
                    {paso.numero}
                  </span>
                  <div className="pt-1">
                    <h4 className="font-literata text-lg font-semibold text-charcoal">
                      {paso.titulo}
                    </h4>
                    <p className="mt-1 text-base text-ink-variant">{paso.texto}</p>
                  </div>
                </li>
              ))}
            </ol>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Beneficios;
